var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJordbrukBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "jordbruk",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182.27 75.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "bce329ed-ea87-44d9-8d75-f9f81163b6e0",
    "data-name": "border",
    d: "M12,21C24.27,19.46,58,18,58.34,18.13s.75-1.83,3.14-3.2,18.43,0,19.92-.63,9-2.11,11.61-5.88c.15-.22,1.33-4.93,3.5-7.21s20.53.12,22.86.8,1.39,2.8-.2,4.27-.12,3.42,3,4.44,1.94,2.39,2.85,6a58.9,58.9,0,0,1,1.25,8.44,37.19,37.19,0,0,0,11,1.37,226.2,226.2,0,0,0,27.53-3.65c9.45-1.93,10.71-3.14,10.71-3.14a6.24,6.24,0,0,1,3.74,3.14c1.59,2.72,3.38,10,2.59,14.17a62,62,0,0,1-13,28.23c-9.81,12-20.35,10.16-30,9.36s-27.29-4.35-49.71-1.47S54.54,70.57,47.2,67.1,25.76,49,21.43,44.29s-9.21-5.81-13.08-9S.27,23.91.27,23.91.85,22.35,12,21Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJordbrukBorder);
export default __webpack_public_path__ + "static/media/jordbruk-border.24f400d9.svg";
export { ForwardRef as ReactComponent };